var path = '/opt/atlassian/pipelines/agent/build/src/app/common/components/display-cover-pic/display-cover-pic.html';
var html = "<div class=cover-pic-area> <div class=\"cover-photo coWih\"> <img ng-image-load={{$ctrl.coverPicUrl}} default-image-key=coverPic class=img-responsive> <div class=caption ng-if=$ctrl.caption>{{$ctrl.caption}}</div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/display-cover-pic/display-cover-pic.html
// module id = 910
// module chunks = 0